import styled from 'styled-components';

export const Content = styled.div`
  position: fixed;
  left: 50%;
  top: 1.5rem;
  font-size: 15px;
  /* right: 0px; */
  /* bottom: 1.5rem; */
  width: 884px; //595
  z-index: 9999;
  color: #e6eaec;
  transform: translateX(-50%);
  background: #161e23;
  border: 1px solid #2c353d;
  box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.55);
  border-radius: 12px;
  * {
    box-sizing: border-box;
  }
  @media (max-width: 639px) {

  }
`;

export const ContentPreview = styled(Content)`
  width: 320px;
`;

export const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
`;

export const Header = styled.div`
  position: relative;
  padding: 0.3rem 40px 0.3rem 0;
  height: 40px;
  line-height: 1;
  background-color: #1a2429;
  border-bottom: 1px solid #2c353d;
  border-radius: 12px 12px 0 0;
  color: #e6eaec;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.div`
  text-align: center;
  font-weight: 600;
`;

export const Left = styled.div`
  flex: 0 0 213px;
  max-width: 213px;
`;

export const Center = styled.div`
  flex-grow: 1;
`;

export const Right = styled.div`
  flex: 0 0 270px;
  max-width: 270px;
  margin-left: 1rem;
  font-size: 12px;
  line-height: 1.2;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0 12px 0 0;
  transition: 0.15s all ease-in;
  border: 0;
  background-color: transparent;
  color: #aab2b8;
  svg {
    width: 14px;
    height: 14px;
    display: block;
  }
  &:hover {
    background-color: #232e35;
    color: #e6eaec;
  }
`;

export const NamePlace = styled.div`
  margin: 0 0 5px;
  /* padding-right: 1rem; */
  input {
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    border-radius: 0 10px 10px 0;
    padding-left: 8px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1rem 1rem;
  button {
    border-radius: 10px;
  }
`;

export const ButtonsRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & > div,
  & > button {
    margin-left: 1rem;
  }
  & > div {
    position: relative;
    button {
      margin: 0;
    }
  }
`;

export const ControlsButtons = styled.div`
  padding: 1.1rem 1rem 0 0;
  button {
    width: 100%;
    border-radius: 10px;
  }
`;
